import angular from 'angular';

angular.module('cloudX').directive('cxConfigurationPicker', [
  '$filter',
  '$rootScope',
  'optionsSvc',
  function($filter, $rootScope, optionsSvc) {
    return {
      restrict: 'E',
      replace: true,
      scope: { disabled: '=' },
      template: `<div>
        <tags-input
          ng-model="selected"
          placeholder="{{('Configuration'|translate)}}"
          display-property="label"
          key-property="value"
          on-tag-added="updateValue()"
          on-tag-removed="updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          class="bootstrap">
          <auto-complete
            source="getSuggestions($query)"
            load-on-focus="true"
            load-on-empty="true"
            display-property="label"
            min-length="0"></auto-complete>
        </tags-input>
      </div>`,
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.selected = [];
        $scope.options = [];
        var findOption = function(code) {
          if (code == null || $scope.options.length === 0) return null;
          return $scope.options.find(function(el) {
            return el.value === code;
          });
        };
        var mapOptions = function() {
          $scope.options = optionsSvc.getOptions('tenantConfiguration');
        };

        $scope.getSuggestions = function(search) {
          return $filter('filter')($scope.options, search);
        };

        $scope.updateValue = function() {
          ngModel.$setViewValue($scope.selected.map(x => x.value));
        };

        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
            $scope.selected = value.map(x => findOption(x));
          }
        };
        mapOptions();
      },
    };
  },
]);
